import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ThemeOptions } from '@frontend/sports/common/ui/shared';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { DsButtonKind } from '@frontend/ui/button';
import { WINDOW } from '@frontend/vanilla/core';
import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

@Component({
    selector: 'bs-betslip-edit-onboarding',
    templateUrl: './edit-bet-onboarding.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./edit-bet-onboarding.scss'],
    standalone: false,
})
export class EditBetOnBoardingComponent {
    module = EpcotModule.MyBetsBetSlip;
    readonly buttonThemeKind: ThemeOptions<DsButtonKind> = { 'sportingbet-br': 'tertiary', 'betboo-br': 'tertiary' };
    private readonly _window = inject(WINDOW);

    constructor(
        public siteCore: Sitecore,
        private activeModal: ActiveModal,
        private trackingService: TrackingService,
    ) {}

    close(): void {
        this.trackingService.track(trackingConstants.EVENT_EDIT_BET, {
            [trackingConstants.PAGE_REFERRING_ACTION]: 'Sports_EditBet_Info_Screen_Close',
            [trackingConstants.PAGE_SITE_SECTION]: 'myBets',
        });
        this.activeModal.close();
    }

    okay(): void {
        this.trackingService.track(trackingConstants.EVENT_EDIT_BET, {
            [trackingConstants.PAGE_REFERRING_ACTION]: 'Sports_EditBet_Info_Screen_OK_Clicked',
            [trackingConstants.PAGE_SITE_SECTION]: 'myBets',
        });
        this.activeModal.close();
    }

    help(): void {
        this._window.open(this.siteCore.betslip.links.help.editbethelp.url, '_blank');
        this.trackingService.track(trackingConstants.EVENT_EDIT_BET, {
            [trackingConstants.PAGE_REFERRING_ACTION]: 'Sports_EditBet_Info_Screen_MoreInfo_Clicked',
            [trackingConstants.PAGE_SITE_SECTION]: 'myBets',
        });
    }
}
